function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $4700161487cf12af$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"aKnk5":"index.23ed359e.js","fM4Gy":"cubetexture.fb234566.jpg"}'));

function $9734543ae57c7d6c$export$ec5db564352962b(gl) {
    const positionBuffer = $9734543ae57c7d6c$var$initPositionBuffer(gl);
    const textureCoordBuffer = $9734543ae57c7d6c$var$initTextureBuffer(gl);
    const indexBuffer = $9734543ae57c7d6c$var$initIndexBuffer(gl);
    const normalBuffer = $9734543ae57c7d6c$var$initNormalBuffer(gl);
    return {
        position: positionBuffer,
        normal: normalBuffer,
        textureCoord: textureCoordBuffer,
        indices: indexBuffer
    };
}
function $9734543ae57c7d6c$var$initPositionBuffer(gl) {
    // Create a buffer for the square's positions.
    const positionBuffer = gl.createBuffer();
    // Select the positionBuffer as the one to apply buffer
    // operations to from here out.
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    const positions = [
        // Front face
        -1,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        1.0,
        1.0,
        1.0,
        -1,
        1.0,
        1.0,
        // Back face
        -1,
        -1,
        -1,
        -1,
        1.0,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        -1,
        -1,
        // Top face
        -1,
        1.0,
        -1,
        -1,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
        1.0,
        -1,
        // Bottom face
        -1,
        -1,
        -1,
        1.0,
        -1,
        -1,
        1.0,
        -1,
        1.0,
        -1,
        -1,
        1.0,
        // Right face
        1.0,
        -1,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        1.0,
        1.0,
        1.0,
        -1,
        1.0,
        // Left face
        -1,
        -1,
        -1,
        -1,
        -1,
        1.0,
        -1,
        1.0,
        1.0,
        -1,
        1.0,
        -1
    ];
    // Now pass the list of positions into WebGL to build the
    // shape. We do this by creating a Float32Array from the
    // JavaScript array, then use it to fill the current buffer.
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    return positionBuffer;
}
function $9734543ae57c7d6c$var$initColorBuffer(gl) {
    const faceColors = [
        [
            1.0,
            1.0,
            1.0,
            1.0
        ],
        [
            1.0,
            0.0,
            0.0,
            1.0
        ],
        [
            0.0,
            1.0,
            0.0,
            1.0
        ],
        [
            0.0,
            0.0,
            1.0,
            1.0
        ],
        [
            1.0,
            1.0,
            0.0,
            1.0
        ],
        [
            1.0,
            0.0,
            1.0,
            1.0
        ]
    ];
    // Convert the array of colors into a table for all the vertices.
    var colors = [];
    for(var j = 0; j < faceColors.length; ++j){
        const c = faceColors[j];
        // Repeat each color four times for the four vertices of the face
        colors = colors.concat(c, c, c, c);
    }
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    return colorBuffer;
}
function $9734543ae57c7d6c$var$initIndexBuffer(gl) {
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    // This array defines each face as two triangles, using the
    // indices into the vertex array to specify each triangle's
    // position.
    const indices = [
        0,
        1,
        2,
        0,
        2,
        3,
        4,
        5,
        6,
        4,
        6,
        7,
        8,
        9,
        10,
        8,
        10,
        11,
        12,
        13,
        14,
        12,
        14,
        15,
        16,
        17,
        18,
        16,
        18,
        19,
        20,
        21,
        22,
        20,
        22,
        23
    ];
    // Now send the element array to GL
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    return indexBuffer;
}
function $9734543ae57c7d6c$var$initTextureBuffer(gl) {
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    const textureCoordinates = [
        // Front
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Back
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Top
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Bottom
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Right
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0,
        // Left
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0
    ];
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoordinates), gl.STATIC_DRAW);
    return textureCoordBuffer;
}
function $9734543ae57c7d6c$var$initNormalBuffer(gl) {
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    const vertexNormals = [
        // Front
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        // Back
        0.0,
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        // Top
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        // Bottom
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        // Right
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        // Left
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        0.0,
        -1,
        0.0,
        0.0
    ];
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertexNormals), gl.STATIC_DRAW);
    return normalBuffer;
}


function $34003bc5868ea94b$export$9ace2719e23fc1c2(gl, programInfo, buffers, texture, cubeRotation) {
    $34003bc5868ea94b$var$resizeCanvasToDisplaySize(gl.canvas);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    gl.clearColor(0.0, 0.0, 0.0, 1.0) // Clear to black, fully opaque
    ;
    gl.clearDepth(1.0) // Clear everything
    ;
    gl.enable(gl.DEPTH_TEST) // Enable depth testing
    ;
    gl.depthFunc(gl.LEQUAL) // Near things obscure far things
    ;
    // Clear the canvas before we start drawing on it.
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    // Create a perspective matrix, a special matrix that is
    // used to simulate the distortion of perspective in a camera.
    // Our field of view is 45 degrees, with a width/height
    // ratio that matches the display size of the canvas
    // and we only want to see objects between 0.1 units
    // and 100 units away from the camera.
    const fieldOfView = 45 * Math.PI / 180 // in radians
    ;
    const aspect = gl.canvas.clientWidth / gl.canvas.clientHeight;
    const zNear = 0.1;
    const zFar = 100.0;
    const projectionMatrix = mat4.create();
    // note: glmatrix.js always has the first argument
    // as the destination to receive the result.
    mat4.perspective(projectionMatrix, fieldOfView, aspect, zNear, zFar);
    // Set the drawing position to the "identity" point, which is
    // the center of the scene.
    const modelViewMatrix = mat4.create();
    // Now move the drawing position a bit to where we want to
    // start drawing the square.
    mat4.translate(modelViewMatrix, modelViewMatrix, [
        -0,
        0.0,
        -6
    ]) // amount to translate
    ;
    let t = mat4.rotate(modelViewMatrix, modelViewMatrix, cubeRotation, [
        0,
        0,
        1
    ]) // axis to rotate around (Z)
    ;
    mat4.rotate(modelViewMatrix, modelViewMatrix, cubeRotation * 0.7, [
        0,
        1,
        0
    ]) // axis to rotate around (Y)
    ;
    mat4.rotate(modelViewMatrix, modelViewMatrix, cubeRotation * 0.3, [
        1,
        0,
        0
    ]) // axis to rotate around (X)
    ;
    const normalMatrix = mat4.create();
    mat4.invert(normalMatrix, modelViewMatrix);
    mat4.transpose(normalMatrix, normalMatrix);
    // Tell WebGL how to pull out the positions from the position
    // buffer into the vertexPosition attribute.
    $34003bc5868ea94b$var$setPositionAttribute(gl, buffers, programInfo);
    $34003bc5868ea94b$var$setTextureAttribute(gl, buffers, programInfo);
    // Tell WebGL which indices to use to index the vertices
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.indices);
    $34003bc5868ea94b$var$setNormalAttribute(gl, buffers, programInfo);
    // Tell WebGL to use our program when drawing
    gl.useProgram(programInfo.program);
    // Set the shader uniforms
    gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
    gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix, false, modelViewMatrix);
    gl.uniformMatrix4fv(programInfo.uniformLocations.normalMatrix, false, normalMatrix);
    // Tell WebGL we want to affect texture unit 0
    gl.activeTexture(gl.TEXTURE0);
    // Bind the texture to texture unit 0
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Tell the shader we bound the texture to texture unit 0
    gl.uniform1i(programInfo.uniformLocations.uSampler, 0);
    {
        const vertexCount = 36;
        const type = gl.UNSIGNED_SHORT;
        const offset = 0;
        gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
    }
}
// Tell WebGL how to pull out the positions from the position
// buffer into the vertexPosition attribute.
function $34003bc5868ea94b$var$setPositionAttribute(gl, buffers, programInfo) {
    const numComponents = 3;
    const type = gl.FLOAT // the data in the buffer is 32bit floats
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set of values to the next
    ;
    // 0 = use type and numComponents above
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.position);
    gl.vertexAttribPointer(programInfo.attribLocations.vertexPosition, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.vertexPosition);
}
// Tell WebGL how to pull out the colors from the color buffer
// into the vertexColor attribute.
function $34003bc5868ea94b$var$setColorAttribute(gl, buffers, programInfo) {
    const numComponents = 4;
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.color);
    gl.vertexAttribPointer(programInfo.attribLocations.vertexColor, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.vertexColor);
}
// tell webgl how to pull out the texture coordinates from buffer
function $34003bc5868ea94b$var$setTextureAttribute(gl, buffers, programInfo) {
    const num = 2 // every coordinate composed of 2 values
    ;
    const type = gl.FLOAT // the data in the buffer is 32-bit float
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set to the next
    ;
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.textureCoord);
    gl.vertexAttribPointer(programInfo.attribLocations.textureCoord, num, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.textureCoord);
}
// Tell WebGL how to pull out the normals from
// the normal buffer into the vertexNormal attribute.
function $34003bc5868ea94b$var$setNormalAttribute(gl, buffers, programInfo) {
    const numComponents = 3;
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.normal);
    gl.vertexAttribPointer(programInfo.attribLocations.vertexNormal, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(programInfo.attribLocations.vertexNormal);
}
function $34003bc5868ea94b$var$resizeCanvasToDisplaySize(canvas) {
    // Lookup the size the browser is displaying the canvas in CSS pixels.
    const displayWidth = canvas.clientWidth;
    const displayHeight = canvas.clientHeight;
    // Check if the canvas is not the same size.
    const needResize = canvas.width !== displayWidth || canvas.height !== displayHeight;
    if (needResize) {
        // Make the canvas the same size
        canvas.width = displayWidth;
        canvas.height = displayHeight;
    }
    return needResize;
}


var $62e4266d682e15e4$exports = {};

$62e4266d682e15e4$exports = new URL((parcelRequire("27Lyk")).resolve("fM4Gy"), import.meta.url).toString();


let $cd33d1601645a65e$var$cubeRotation = 0.0;
let $cd33d1601645a65e$var$deltaTime = 0;
$cd33d1601645a65e$var$main();
function $cd33d1601645a65e$var$main() {
    const canvas = document.querySelector("#glcanvas");
    const gl = canvas.getContext("webgl");
    if (gl === null) {
        alert("Unable to initialize WebGL. Your browser or machine may not support it.");
        return;
    }
    // Vertex shader program
    const vsSource = `
  attribute vec4 aVertexPosition;
  attribute vec3 aVertexNormal;
  attribute vec2 aTextureCoord;

  uniform mat4 uNormalMatrix;
  uniform mat4 uModelViewMatrix;
  uniform mat4 uProjectionMatrix;

  varying highp vec2 vTextureCoord;
  varying highp vec3 vLighting;

  void main(void) {
    gl_Position = uProjectionMatrix * uModelViewMatrix * aVertexPosition;
    vTextureCoord = aTextureCoord;

    // Apply lighting effect

    highp vec3 ambientLight = vec3(0.3, 0.3, 0.3);
    highp vec3 directionalLightColor = vec3(1, 1, 1);
    highp vec3 directionalVector = normalize(vec3(0.85, 0.8, 0.75));

    highp vec4 transformedNormal = uNormalMatrix * vec4(aVertexNormal, 1.0);

    highp float directional = max(dot(transformedNormal.xyz, directionalVector), 0.0);
    vLighting = ambientLight + (directionalLightColor * directional);
  }
`;
    // Fragment shader program
    const fsSource = `
  varying highp vec2 vTextureCoord;
  varying highp vec3 vLighting;

  uniform sampler2D uSampler;

  void main(void) {
    highp vec4 texelColor = texture2D(uSampler, vTextureCoord);

    gl_FragColor = vec4(texelColor.rgb * vLighting, texelColor.a);
  }
`;
    // Initialize a shader program this is where all the lighting
    // for the vertices and so forth is established.
    const shaderProgram = $cd33d1601645a65e$var$initShaderProgram(gl, vsSource, fsSource);
    // Collect all the info needed to use the shader program.
    // Look up which attributes our shader program is using
    // for aVertexPosition, aVertexColor and also
    // look up uniform locations.
    const programInfo = {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            textureCoord: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            uSampler: gl.getUniformLocation(shaderProgram, "uSampler")
        }
    };
    // Here's where we call the routine that builds all the
    // objects we'll be drawing.
    const buffers = (0, $9734543ae57c7d6c$export$ec5db564352962b)(gl);
    // Load texture
    const texture = $cd33d1601645a65e$var$loadTexture(gl, (0, (/*@__PURE__*/$parcel$interopDefault($62e4266d682e15e4$exports))));
    // Flip image pixels into the bottom-to-top order that WebGL expects.
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    let then = 0;
    // Draw the scene repeatedly
    function render(now) {
        now *= 0.001 // convert to seconds
        ;
        $cd33d1601645a65e$var$deltaTime = now - then;
        then = now;
        (0, $34003bc5868ea94b$export$9ace2719e23fc1c2)(gl, programInfo, buffers, texture, $cd33d1601645a65e$var$cubeRotation);
        $cd33d1601645a65e$var$cubeRotation += $cd33d1601645a65e$var$deltaTime;
        requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
}
//
// Initialize a shader program, so WebGL knows how to draw our data
//
function $cd33d1601645a65e$var$initShaderProgram(gl, vsSource, fsSource) {
    const vertexShader = $cd33d1601645a65e$var$loadShader(gl, gl.VERTEX_SHADER, vsSource);
    const fragmentShader = $cd33d1601645a65e$var$loadShader(gl, gl.FRAGMENT_SHADER, fsSource);
    // Create the shader program
    const shaderProgram = gl.createProgram();
    gl.attachShader(shaderProgram, vertexShader);
    gl.attachShader(shaderProgram, fragmentShader);
    gl.linkProgram(shaderProgram);
    // If creating the shader program failed, alert
    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
        alert(`Unable to initialize the shader program: ${gl.getProgramInfoLog(shaderProgram)}`);
        return null;
    }
    return shaderProgram;
}
//
// creates a shader of the given type, uploads the source and
// compiles it.
//
function $cd33d1601645a65e$var$loadShader(gl, type, source) {
    const shader = gl.createShader(type);
    // Send the source to the shader object
    gl.shaderSource(shader, source);
    // Compile the shader program
    gl.compileShader(shader);
    // See if it compiled successfully
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        alert(`An error occurred compiling the shaders: ${gl.getShaderInfoLog(shader)}`);
        gl.deleteShader(shader);
        return null;
    }
    return shader;
}
//
// Initialize a texture and load an image.
// When the image finished loading copy it into the texture.
//
function $cd33d1601645a65e$var$loadTexture(gl, url) {
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    // Because images have to be downloaded over the internet
    // they might take a moment until they are ready.
    // Until then put a single pixel in the texture so we can
    // use it immediately. When the image has finished downloading
    // we'll update the texture with the contents of the image.
    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([
        0,
        0,
        255,
        255
    ]) // opaque blue
    ;
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
    const image = new Image();
    image.onload = ()=>{
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
        // WebGL1 has different requirements for power of 2 images
        // vs non power of 2 images so check if the image is a
        // power of 2 in both dimensions.
        if ($cd33d1601645a65e$var$isPowerOf2(image.width) && $cd33d1601645a65e$var$isPowerOf2(image.height)) // Yes, it's a power of 2. Generate mips.
        gl.generateMipmap(gl.TEXTURE_2D);
        else {
            // No, it's not a power of 2. Turn off mips and set
            // wrapping to clamp to edge
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        }
    };
    image.src = url;
    return texture;
}
function $cd33d1601645a65e$var$isPowerOf2(value) {
    return (value & value - 1) === 0;
}


//# sourceMappingURL=index.23ed359e.js.map
